import { iconPaths, type IconName } from "./iconPaths";

export type { IconName };

interface IconProps {
  name: IconName;
  size?: number | string;
  className?: string;
  /** Supply a label to expose the icon to assistive tech; omit for decoration. */
  title?: string;
}

/**
 * Inline SVG glyph. Paths come from a static registry, so the markup is
 * generated entirely from our own data — never from user input.
 */
export function Icon({ name, size, className, title }: IconProps) {
  const d = iconPaths[name];

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      width={size}
      height={size}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
      // The registry is a compile-time constant of our own authoring.
      dangerouslySetInnerHTML={{ __html: title ? `<title>${title}</title>${d}` : d }}
    />
  );
}
